//IE Polyfill for support for 'forEach'
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        var i;
        thisArg = thisArg || window;
        for (i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
gsap.config({ nullTargetWarn: false });
gsap.registerPlugin(ScrollTrigger);
gsap.registerEase('custom', CustomEase.create("custom1", "M0,0 C0.11,0.22 0.275,1.27 1,1"));
CustomEase.create("customExpo", "0.90, 0.00, 0.10, 1.00");
CustomEase.create("customExpoOut", "0.14, 1.00, 0.34, 1.00");

let revealContainers = document.querySelectorAll(".reveal");

const dur = 1.8;
revealContainers.forEach((container) => {
    let imgReveal = container.querySelector(".img-reveal");
    let stack = container.querySelector(".stack > div");
    let copy = container.querySelector("p");
    let subHeading = container.querySelector("h3");
    let revealImg = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            toggleActions: "play none none none",
        },
    });

    revealImg
        .set(imgReveal, { autoAlpha: 1 })
        .from(imgReveal, 1.5, {})
        .from(
            subHeading,
            {
                duration: dur,
                ease: "customExpo",
                stagger: dur,
                x: -30,
                autoAlpha: 0,
            },
            "-=1.3"
        )
        .fromTo(
            stack,
            {
                opacity: 0,
                x: -30,
            },
            {
                opacity: 1,
                x: 0,
                duration: dur,
                ease: "customExpo",
            },
            "-=1.9"
        )
        .fromTo(
            copy,
            {
                opacity: 0,
                x: -30,
            },
            {
                opacity: 1,
                x: 0,
                duration: dur,
                ease: "customExpo",
            },
            "-=2"
        );
});

(() => {
    let isTest = {}
    // isTest = { toggleActions: 'restart none none reverse' }
    const baseEase = 'slow(0.7, 0.7, false)'

    // Skyline
    function runSkyline(selector) {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: selector,
            start: 'top 70%',
            ...isTest
          }
        });

        tl.from(`${selector} .skyline-content`, { opacity: 0, duration: 0.8 });

        gsap.registerPlugin(DrawSVGPlugin);
        const images = document.querySelectorAll(`${selector} .swiper-wrapper > div`);
        const nextArrow = document.querySelector(`${selector} .swiper-button-next`);

        const skylineTl = gsap.timeline(
            {
                scrollTrigger: {
                    trigger: `${selector} .sections`,
                    start: 'top center',
                    paused: true,
                    ...isTest
                }
            })
            .from(`${selector} .skyline`, 1, {
                drawSVG: "100% 100%",
                duration: 2,
                ease: baseEase
            })
            .from(images, 1, {
                autoAlpha: 0,
                stagger: 0.3,
                ease: Power2.easeOut
            })
            .from(`${selector} .skyline-white`, 1, {
                drawSVG: "100% 100%",
                duration: 1,
                delay: 0.1,
                ease: baseEase,
            }, "-=1.1")
            .from(nextArrow, { opacity: 0, x: '-50%', ease: baseEase, onComplete: () => gsap.set(nextArrow, { clearProps: 'all'})}, '-=1')

        return [tl, skylineTl];
    }

    const [tlFragrance, tlFragranceSkyline] = runSkyline('.hp-fragrance');
    const [tlAmenities, tlAmenitiesSkyline] = runSkyline('.hp-amenities');

    // HP Scroll Animations
    const clipReveal = {
        from: { 'clip-path': 'polygon(0 0, 0 0, 0 100%, 0% 100%)' },
        to: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', duration: .5 }
    }

    function animHpHeading () {
        const hpHeading = document.querySelectorAll('.main-hp h1 div');
        const hpHeadingContent = document.querySelectorAll('.main-hp h1 span');
        const tlHpHeading = gsap.timeline();
        const tltEasing = 'customExpo';

        tlHpHeading
            .staggerFromTo(hpHeading, 1, { ...clipReveal.from }, { ...clipReveal.to, ease: tltEasing }, 0.2)
            .staggerFromTo(hpHeadingContent, 1, { opacity: 0 }, { opacity: 1, delay: -.4 }, '.3');
        ;
    }

    animHpHeading()

    // HP Category
    const tlCategoryDefaults = {
        duration: 0.6,
        // ease: Cubic.easeInOut(0.84, 0, 0.16, 1) // ease from after effects
        ease: baseEase
    }

    function animCatHero (trigger) {
        if(!trigger) return;

        const prodImage     = trigger.querySelector('.product-wrap img');
        const button        = trigger.querySelector('h2');
        const buttonContent = trigger.querySelector('h2 span');
        const content       = trigger.querySelector('.category-content');

        const inverted = trigger.closest('.hp-category').classList.contains('hp-category--inverted');

        const prodPosX = (inverted) ? '11%' : '-11%';

        const tlCatHero = gsap.timeline({
            defaults: { ...Object.assign(tlCategoryDefaults) },
            scrollTrigger: {
                trigger: trigger,
                start: 'top 60%',
                ...isTest
            }
        });

        tlCatHero
            .fromTo(
                prodImage,
                { x: prodPosX, y: '-11%' },
                { x: '0%', y: '0%' }
            )
            .fromTo(
                button,
                clipReveal.from,
                clipReveal.to
            )
            .from(content, { autoAlpha: 0, duration: 1 }, `-=${tlCategoryDefaults.duration}`)
            .from(buttonContent, { opacity: 0 }, `-=${tlCategoryDefaults.duration}`)
        ;
    }

    function animCatItems (trigger, elTarget) {
        if(!trigger) return;

        elTarget            = elTarget || trigger.querySelector('[data-swiper-slide-index="0"]');
        const prodImage     = elTarget.querySelector('picture');
        const ornamentImage = elTarget.querySelector('.artistic-ornament');
        const button        = elTarget.querySelector('h2');
        const buttonContent = button.querySelector('span');
        const prevArrow     = trigger.querySelector('.swiper-button-prev');
        const nextArrow     = trigger.querySelector('.swiper-button-next');

        const inverted = trigger.closest('.hp-category').classList.contains('hp-category--inverted');

        const [ prodPosX, artPosX] = (inverted)
            ? ['6%', '-6%']
            : [ '-6%', '6%']
        ;

        const tlCatItems = gsap.timeline({
            default: { ...tlCategoryDefaults },
            scrollTrigger: {
                trigger: trigger,
                start: 'top 60%',
                ...isTest
            }
        });

        tlCatItems
            .from(trigger, { opacity: 0 })
            .fromTo(
                prodImage,
                { x: prodPosX, y: '6%' },
                { x: '0%', y: '0%' },
                0
            )
            .fromTo(
                ornamentImage,
                { x: artPosX, y: '-6%' },
                { x: '0%', y: '0%' },
                0
            )
            .fromTo(
                button,
                clipReveal.from,
                clipReveal.to
            )
            .from(buttonContent, tlCategoryDefaults.duration, { opacity: 0 });

        if (arguments.length === 1) {
            tlCatItems
                .from(prevArrow, { opacity: 0, x: '50%', clearProps: 'x' }, '-=1.2')
                .from(nextArrow, { opacity: 0, x: '-50%', clearProps: 'x' }, '-=1.2')
            ;
        }

        return tlCatItems;
    }

    const categoryTrigger      = document.querySelector('.hp-category.bedding .category-hero')
    const categoryTriggerI     = document.querySelector('.hp-category--inverted .category-hero')
    const categoryItemTrigger  = document.querySelector('.hp-category.bedding .category-items')
    const categoryItemTriggerI = document.querySelector('.hp-category--inverted .category-items')

    animCatHero(categoryTrigger)
    animCatHero(categoryTriggerI)
    animCatItems(categoryItemTrigger)
    animCatItems(categoryItemTriggerI)

    // HP Draw line
    const tlLine1 = gsap.timeline(
        {
            defaults: { ...tlCategoryDefaults },
            scrollTrigger: {
                trigger: categoryTrigger,
                start: 'top 60%',
                ...isTest,
            }
        })
        .fromTo(
            '#first-line path',
            { drawSVG: '0%' },
            { drawSVG: "100%", duration: 2.8, ease: baseEase }
        )
        .from(
            '.hp-category.bedding .art-accent',
            { autoAlpha: 0 }, '-=2'
        )
    ;

    const tlLine2 = gsap.timeline(
        {
            defaults: { ...tlCategoryDefaults },
            scrollTrigger: {
                trigger: '.hp-fragrance',
                start: 'top 90%',
                ...isTest
            }
        })
        .fromTo(
            '.bedding #second-line path',
            { drawSVG: '0%' },
            { drawSVG: "100%", duration: 0.8, ease: baseEase }
        )
        .fromTo(
            '.bedding #second-line-end path',
            { drawSVG: '0%' },
            { drawSVG: "100%", duration: 2,ease: baseEase }
        )
    ;

    const tlLine3 = gsap.timeline(
        {
            defaults: { ...tlCategoryDefaults },
            scrollTrigger: {
                trigger: categoryTriggerI,
                start: 'top center',
                ...isTest,
            }
        })
        .fromTo(
            '#third-line path',
            { drawSVG: '0%' },
            { drawSVG: "100%", duration: 2.8, ease: baseEase }
        )
        .from(
            '.hp-category.bath .art-accent',
            { autoAlpha: 0 }, '-=2'
        )
    ;

    const tlLine4 = gsap.timeline(
        {
            defaults: { ...tlCategoryDefaults },
            scrollTrigger: {
                trigger: '.hp-amenities',
                start: 'top 90%',
                ...isTest
            }
        })
        .fromTo(
            '.bath #second-line path',
            { drawSVG: '0%' },
            { drawSVG: "100%", duration: 0.8, ease: baseEase }
        )
        .fromTo(
            '.bath #second-line-end path',
            { drawSVG: '0%' },
            { drawSVG: "100%", duration: 2,ease: baseEase }
        )
    ;

    // HP Write Letters
    const runAnimation = () => {
        const hpLetters = document.querySelectorAll('.seo .word span');

        const tlTypeLetters = gsap.timeline({
            scrollTrigger: {
                trigger: '.seo h3',
                start: 'top 60%',
                ...isTest
            }
        });

        tlTypeLetters
            .staggerFrom(hpLetters, .6, {
                autoAlpha: 0,
                delay: 0,
                ease: baseEase
            }, 0.1)
            .from('.seo p', {
                autoAlpha: 0,
                duration: 1,
                ease: 'none'
            }, '-=.2')
        ;
    }

    document.addEventListener('breakLettersExecuted', runAnimation)
})();
